'use strict';

(function (angular) {
  angular.module('zp').controller('VendorController', vendorController);

  /**@ngInject */
  function vendorController($state, $q, $rootScope, vendorsService, mapConfig, mapService, LoaderService, authService, $uibModal, $window, notify, $timeout, SlugerService) {
    var vm = this;

    vm.vendor = null;
    vm.currentImage = null;
    vm.myInterval = 5000;
    vm.noWrapSlides = false;
    vm.selectImage = selectImage;
    vm.mapMarkers = [];
    vm.mapOptions = angular.copy(mapConfig.mapOptions);
    vm.offeredVendors = [];
    vm.relatedVendors = [];

    var width = $window.innerWidth > 1200 ? "350px" : $window.innerWidth > 700 ? "310px" : "260px";
    vm.relatedGridStyle = [{
      "width": width,
      "height": "200px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": width,
      "height": "200px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": width,
      "height": "200px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }, {
      "width": width,
      "height": "200px",
      "display": "block",
      "background": "url('{{backgroundUrl}}') 50% 0% no-repeat",
      "background-size": "cover"
    }];

    vm.showDirections = showDirections;
    vm.openItem = openItem;
    vm.addToFavourite = addToFavourite;
    vm.like = like;
    vm.isVendorFavourited = isVendorFavourited;
    vm.openWebsite = openWebsite;

    /**@ngInject */
    (function () {
      LoaderService.start().then(loadVendor).then(setMapOptions).then(setCurrentImage).then(function () {
        var p1 = loadOfferedVendors();
        var p2 = loadRelatedVendors();
        return $q.all([p1, p2]);
      }).then(LoaderService.stop);
    })();

    function loadVendor() {
      if ($state.params.vendorId) {
        return vendorsService.getOne($state.params.vendorId, $state.params.vendor).then(function (response) {
          $state.go('nav.vendor-slug', { vendor: response.category, slugCity: SlugerService.generateSlug(response.city), slugName: SlugerService.generateSlug(response.name) });
          return $q.reject('Redirecting to the new vendor state');
          // vm.vendor = response;
          // vm.mapMarkers.push(vm.vendor.location);
        });
      } else if ($state.params.slugCity && $state.params.slugName) {
        return vendorsService.getOneBySlugs($state.params.vendor, $state.params.slugCity, $state.params.slugName).then(function (response) {
          vm.vendor = response;
          vm.mapMarkers.push(vm.vendor.location);
        });
      } else {
        $q.reject('Missing vendor identificator or slugs');
      }
    }

    function loadOfferedVendors() {
      return vendorsService.getAll().then(function (categories) {
        var c = categories.find(function (item) {
          return item.name === $state.params.vendor;
        });
        if (!c) {
          return false;
        }
        var promisses = [];
        for (var i = 0; i < c.offeredCategories.length; i++) {
          promisses.push(vendorsService.getRandom(c.offeredCategories[i], 1));
        }
        return $q.all(promisses).then(function (responses) {
          vm.offeredVendors = [responses[0][0], responses[1][0], responses[2][0]];
        });
      });
    }

    function loadRelatedVendors() {
      return vendorsService.getRandom($state.params.vendor, 4).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          res[i].style = vm.relatedGridStyle[i];
          res[i].style.background = res[i].style.background.replace('{{backgroundUrl}}', res[i].images[0].url);
        }
        vm.relatedVendors = res;
      });
    }

    function setCurrentImage() {
      return $q.when(function () {
        vm.currentImage = vm.vendor.images[1];
      }());
    }

    function selectImage(image) {
      vm.currentImage = image;
    }

    function setMapOptions() {
      return $q.when(function () {
        vm.mapOptions.mapCenter = vm.mapMarkers.length ? vm.mapMarkers[0] : null;
        vm.mapOptions.disableDefaultUI = true;
        vm.mapOptions.zoomControl = true;
        vm.mapOptions.streetViewControl = false;
        vm.mapOptions.draggable = true;
        vm.mapOptions.scrollwheel = false;
        vm.mapOptions.disableDoubleClickZoom = true;
        return true;
      }());
    }

    function showDirections() {
      var destination = {
        address: vm.vendor.location.address,
        lat: vm.vendor.location.latitude,
        lng: vm.vendor.location.longitude
      };
      return mapService.navigate(null, destination);
    }

    function openItem(item) {
      $state.go('nav.vendor-slug', { vendor: item.category, slugCity: SlugerService.generateSlug(item.city), slugName: SlugerService.generateSlug(item.name) });
    }

    function addToFavourite() {
      return tryToLoginUser('Da bi ste dodali u Vaš MIX potrebno je ra se Prijavite, tj da se Registrujete ukoliko već nemate nalog.').then(function () {
        if (isVendorFavourited(vm.vendor)) {
          return $q.reject(vm.vendor.name + ' se već nalazi u Vašem MIX-u');
        }
        var user = $rootScope.currentUser;
        if (!user.favourites[vm.vendor.category]) {
          user.favourites[vm.vendor.category] = [];
        }
        user.favourites[vm.vendor.category].push(vm.vendor.id);
        return authService.update(user);
      }).then(function () {
        return vendorsService.favourite(vm.vendor, vm.vendor.category);
      }).then(function (response) {
        vm.vendor.favsCount = response.favsCount;
      }).catch(function (err) {
        notify({ message: err, classes: ['warning'], position: 'right' });
      });
    }

    function like() {
      return vendorsService.like(vm.vendor, vm.vendor.category).then(function (response) {
        vm.vendor.likeCount = response.likeCount;
      }).catch(function (err) {
        notify({ message: err, classes: ['error'], position: 'right' });
      });
    }

    function isVendorFavourited(vendor) {
      if (!vendor) {
        return false;
      }
      return $rootScope.currentUser && $rootScope.currentUser.favourites && $rootScope.currentUser.favourites[vendor.category] && $rootScope.currentUser.favourites[vendor.category].indexOf(vendor.id) !== -1;
    }

    function tryToLoginUser(text) {
      if ($rootScope.currentUser) {
        return $q.when(function () {
          return true;
        }());
      }
      var defered = $q.defer();
      $uibModal.open({
        animation: true,
        templateUrl: 'app/auth/auth.login.html',
        controller: 'LoginController',
        controllerAs: 'vm',
        resolve: {
          options: function options() {
            return {
              text: text
            };
          }
        }
      }).result.then(function (success) {
        if (success) {
          defered.resolve();
        } else {
          defered.reject();
        }
      });
      return defered.promise;
    }

    function openWebsite() {
      $window.open(agency.website, '_blank');
    }
  }
})(window.angular);